import moment from "moment";
import config from "config/config";
import { getToken } from "js/formatting/getToken";

export async function getPolicyQuote(policyId) {
  let options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": config.ODS_API_KEY,
      Authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify({
      gXdpApi: {
        transactionType: {
          sourceNameSpace: "LIFESYS",
          eventName: "GETQUOTE",
          targetNameSpace: "GIDP",
          operation: "GET",
        },
        gIdpPayLoad: {
          policyHolder: {
            contractId: policyId,
          },
          addOnProperties: {
            lifesys: {
              policyHolder: {
                company: config.COMPANY,
                clientName: config.CLIENTNAME,
                system: "LSN",
                showLogTimeStamp: "Y",
                lifeSysDataset: "P",
              },
            },
          },
        },
        parentCorrelationID: moment().format("YYYY-MM-DD HH:MM:SS"),
        correlationID: moment().format("YYYY-MM-DD HH:MM:SS"),
        addOnProperties: {},
      },
    }),
  };
  const response = await fetch(
    config.ODS_API_BASE_URL + "/evl/GetPolicyQuote",
    options
  );
  if (!response.ok) {
    throw response;
  } else {
    const data = await response.json();
    if (data?.gXdpApi?.success) {
      return data.gXdpApi?.gIdpPayLoad?.policy?.quoteDetails;
    }
    return;
  }
}
